import React from 'react';

import { LiveSearchLoader } from '@confluence/live-search/entry-points/liveSearchLoader.ts';
import {
	getExperienceName,
	getMacroAttributesFromADFNode,
} from '@confluence/macro-tracker/entry-points/MacroExperienceTracker.ts';
import { MacroExperienceSuccess } from '@confluence/macro-tracker/entry-points/MacroExperienceSuccess.ts';
import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import { extensionToADF } from '@confluence/fabric-extension-lib/entry-points/editor-extensions.ts';

type LiveSearchHandlerProps = {
	macroDefaultProps: ExtensionHandlerProps;
};

export const LiveSearchHandler = ({
	macroDefaultProps,
}: LiveSearchHandlerProps): React.JSX.Element => {
	const { contentId, extensionKey, node, mode } = macroDefaultProps;
	const attributes = getMacroAttributesFromADFNode(node);

	return (
		<>
			<LiveSearchLoader macroNode={extensionToADF(node)} />
			<MacroExperienceSuccess
				name={getExperienceName(mode, node)}
				contentId={contentId}
				extensionKey={extensionKey}
				mode={mode}
				attributes={attributes}
			/>
		</>
	);
};
